<template>
  <div class="pageContent">
 <!-- 数据展示区域 -->
    <div class="showDataView">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column
          prop="productName"
          label="产品名称">
        </el-table-column>
        <el-table-column
          prop="productKey"
          label="productKey">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="添加时间">
        </el-table-column>
        <el-table-column
          prop="batchNum"
          label="添加数量">
        </el-table-column>
        <el-table-column
          label="创建状态">
          <template slot-scope="scope">
            <div v-if="scope.row.createStatus === 1" class="success">
              成功
            </div>
            <div v-if="scope.row.createStatus === -1" class="fail">
              失败
            </div>
             <div v-if="scope.row.createStatus === 0">
              正在创建<span class="el-icon-loading"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header">
            操作
        <el-tooltip :content="operationTips" placement="top" effect="light">
          <span class="el-icon-question"></span>
        </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div class="opreationBtn">
              <span class="detail" v-if="scope.row.isError" @click="getErrorDetail(scope.row)">异常数据</span>
              <span class="detail" v-if="scope.row.createStatus === 1" @click="getDetail(scope.row)">详情</span>
               <span v-if="scope.row.createStatus !== -1 && scope.row.batchSecretAddress" class="detail" @click="download(scope.row.batchSecretAddress)">下载CSV</span>
            </div>
           </template>

        </el-table-column>
      </el-table>

      <Paging
          :total="pageParams.total"
          pagingStatus=""
          @changePage="currentPageChange"/>

    </div>
    <!-- 详情数据 -->
  <batchDeviceDetailView
  @current-page-change="batchCurrentPageChange"
    @close-view="closeView"
    :batchPageParams="batchPageParams"
    :batchDeviceList="batchDeviceList"
    :batchDetail="batchDetail"
    :showDetailView="showDetailView">
  </batchDeviceDetailView>

  <!-- 错误详情数据 -->
  <batchDeviceErrorDetailView
  @current-page-change="batchErrorCurrentPageChange"
    @close-view="showErrorDetailView.show = false"
    :batchPageParams="batchErrorPageParams"
    :url="errorExcelUrl"
    :batchDeviceList="batchDeviceList"
    :batchDetail="batchDetail"
    :showDetailView="showErrorDetailView">
  </batchDeviceErrorDetailView>

  </div>
</template>
<script>
import { getBatchDeviceList, batchDeviceDetail, batchErrorDeviceDetail } from '@/api/deviceManagement'
import { eventBus } from '@/utils/eventBus'
// import { dataFormat } from '@/utils'
import batchDeviceDetailView from '@/components/deviceManage/batchDeviceDetailView'
import batchDeviceErrorDetailView from '@/components/deviceManage/batchDeviceErrorDetailView'
import Paging from '@/components/paging'
import { loadFileByUrl } from '@/utils'
export default {
  components: {
    batchDeviceDetailView,
    batchDeviceErrorDetailView,
    Paging
  },
  props: {
    productKey: {
      type: String
    }
  },
  data () {
    return {
      tableData: [],
      pageParams: {
        pageNumber: 1,
        pageSize: 5,
        total: 0
      },
      operationTips: '您可按批次下载设备激活凭证（.csv），批量烧录到设备中。',
      drawerParams: {
        showDrawer: false
      },
      batchDeviceList: [],
      batchPageParams: {
        pageNumber: 1,
        pageSize: 5,
        total: 0
      },
      batchErrorPageParams: {
        pageNumber: 1,
        pageSize: 5,
        total: 0
      },
      batchDetail: {
        productName: '',
        createTime: '',
        batchNum: '',
        batchSecretAddress: ''
      },
      showDetailView: {
        show: false
      },
      showErrorDetailView: {
        show: false
      },
      errorExcelUrl: ''
    }
  },
  methods: {
    getErrorDetail (rowDetail) {
      console.log('获取错误信息详情：', rowDetail)
      // 点击详情每次页面初始化为第一页
      this.batchErrorPageParams.pageNumber = 1
      this.linkErrorDetail(rowDetail)
    },
    getDetail (rowDetail) {
      // 点击详情每次页面初始化为第一页
      this.batchPageParams.pageNumber = 1
      this.linkDetail(rowDetail)
    },
    linkDetail (rowDetail) {
      const row = rowDetail || this.row
      this.row = row
      this.batchDetail = row
      debugger
      console.log('row:', row)
      const params = {
        batchId: row.batchId,
        addVersion: row.addVersion,
        pageNumber: this.batchPageParams.pageNumber,
        pageSize: this.batchPageParams.pageSize,
        productKey: row.productKey
      }
      batchDeviceDetail(params).then(res => {
        res = res.data
        console.log('批次详情：', res)
        res.code === 200
          ? (
            this.batchDeviceList = res.data.data,
            this.batchPageParams.total = res.data.total,
            // 详情获取到再打开抽屉
            this.showDetailView.show = true
          )
          : this.$message({
            showClose: true,
            message: '请求失败，请稍后重试',
            type: 'error'
          })
      })
    },
    linkErrorDetail (rowDetail) {
      const row = rowDetail || this.row
      this.row = row
      this.batchDetail = row
      console.log('row:', row)
      const params = {
        batchId: row.batchId,
        addVersion: row.addVersion,
        pageNumber: this.batchErrorPageParams.pageNumber,
        pageSize: this.batchErrorPageParams.pageSize,
        productKey: row.productKey
      }
      console.log(JSON.stringify(params))
      batchErrorDeviceDetail(params).then(res => {
        res = res.data
        console.log('批次非法详情：', res)
        res.code === 200
          ? (
            this.batchDeviceList = res.data.data,
            this.errorExcelUrl = res.data.url,
            this.batchErrorPageParams.total = res.data.total,
            // 详情获取到再打开抽屉
            this.showErrorDetailView.show = true
          )
          : this.$message({
            showClose: true,
            message: '请求失败，请稍后重试',
            type: 'error'
          })
      })
    },
    getDeviceList () {
      const params = {
        listType: 1, // 1： 获取批次管理的设备列表
        pageNumber: this.pageParams.pageNumber,
        pageSize: this.pageParams.pageSize,
        productKey: this.productKey
      }

      getBatchDeviceList(params)
        .then(res => {
          res = res.data
          console.log('获取批次设备列表数据:', res)
          console.log('res.data设备：', res.data.data)
          const list = res.data.data
          this.pageParams.total = res.data.total
          // list.map((item, index) => {
          //   // console.log(item)
          //   item.lastOnlineTime = item.lastOnlineTime ? dataFormat(item.lastOnlineTime) : '暂无记录'
          //   item.status = item.isEnable && item.isActive && item.deviceStatus === 'ONLINE'
          //   item.statusText = item.isEnable
          //     ? item.isActive
          //       ? ['在线', '离线']
          //       : ['已激活', '未激活']
          //     : ['启用', '禁用']
          // })
          console.log('list:', list)
          this.tableData = list
        })
    },
    currentPageChange (val) {
      Object.assign(this.pageParams, {
        pageSize: val.limit,
        pageNumber: val.page
      })
      // this.pageParams.pageNumber = num
      this.getDeviceList()
    },
    batchCurrentPageChange (listQuery) {
      Object.assign(this.batchPageParams, {
        pageSize: listQuery.limit,
        pageNumber: listQuery.page
      })
      // this.batchPageParams.pageNumber = num
      this.linkDetail()
    },
    batchErrorCurrentPageChange (listQuery) {
      Object.assign(this.batchErrorPageParams, {
        pageSize: listQuery.limit,
        pageNumber: listQuery.page
      })
      // this.batchPageParams.pageNumber = num
      this.linkErrorDetail()
    },
    download (path) {
      if (path) {
        // window.open(path)
        loadFileByUrl(path)
      } else {
        this.$message.error('下载出错')
      }
    },
    closeView () {
      console.log('closeView')
      // 关闭批量详情弹窗
      this.showDetailView.show = false
    }
  },
  created () {
    this.getDeviceList()
    eventBus.$on('get-multi-device-list', this.getDeviceList)
  },
  watch: {
    productKey () {
      console.log('batchproductKey改变')
      // 重新刷新获取数据
      this.getDeviceList()
    }
  }
}
</script>
<style lang="less" scope>
.pageContent{
  .showDataView{
    background-color: white;
    .el-icon-question{
      margin-left: 5px;
      color: rgb(204, 204, 204);
    }
    .opreationBtn{
      .detail{
        color: #35a6df;
        cursor: pointer;
      }
    }
    .showAll{
      display: flex;
      align-items: center;
      span{
        color: #f0bd95;
      }
    }
    .success{
      color: #138c4b;
    }
    .fail{
      color: #ff090b;
    }
  }
  .showDataView2{
    background-color: white;
    position: absolute;
    width: 100%;
    height: 100%;
    .opreationBtn{
      .detail{
        color: #35a6df;
        cursor: pointer;
      }
    }
  }
  .dataListOperation{
      // padding:20px;
      .showAll{
        display: flex;
        align-items: center;
        span{
          color: #f0bd95;
        }
      }
  }
  // .el-drawer__body{
  //   margin: 10px 20px;
  //   display: flex;
  //   flex-direction: column;
  // }
  // .el-drawer__title{
  //   font-size: 20px;
  // }
  // .drawer{
  //   .title{
  //     font-size: 20px;
  //   }
  //   .detailContent{
  //     display: flex;
  //     background-color: #fbfbfc;
  //     border: 1px solid #ecedee;
  //     padding: 20px;
  //     .flex1{
  //       flex:auto;

  //     }
  //   }
  //   .flex1{
  //     flex:auto;
  //     position: relative;
  //     margin-top: 20px;
  //   }
  //   .cgray-01{
  //     color: rgb(51, 51, 51)
  //   }
  //   .cgray-02{
  //     color: rgb(85, 85, 85)
  //   }
  //   .fs10{
  //     font-size: 10px;
  //   }
  //   .footer{
  //     padding: 20px 10px ;
  //   }
  // }
}
</style>
